import axios from 'axios'

export default {
  getCurrentUser () {
    return axios.get('/api/user/current-user')
  },
  login (data) {
    return axios.post('/api/user/_login', data)
  },
  logout () {
    return axios.delete('/api/user/_logout')
  }
}
